import axios from 'axios';
// axios.defaults.baseURL =  'http://localhost:19401/api'; el front se ejecuta donde esta el servidor
//axios.defaults.baseURL='http://192.168.2.168:19405/api'; // para que sea accesible en la misma red del servidor
axios.defaults.baseURL='/api'; // PRODUCCION
axios.interceptors.request.use(
  (config) => {
    const token_seguridad = window.localStorage.getItem('token_seguridad');

    if (token_seguridad) {
      config.headers.Authorization = 'Bearer ' + token_seguridad;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       window.localStorage.removeItem('token_seguridad');
//       window.localStorage.removeItem('sesionUsuario');

//       window.location.href = '/login';
//     }

//     return Promise.reject(error);
//   }
// );
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const urlPeticion =
        error.config?.url?.toLowerCase() || '';

      const rutaActual = window.location.pathname
        .replace(/\/+$/, '')
        .toLowerCase();

      const estaEnLogin = rutaActual === '/login';

      const esPeticionLogin =
        urlPeticion.includes('/usuario/login');

      // No recargar si ya estamos en login
      // Tampoco redirigir si las credenciales fueron incorrectas
      if (!estaEnLogin && !esPeticionLogin) {
        window.localStorage.removeItem('token_seguridad');
        window.localStorage.removeItem('sesionUsuario');

        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  }
);

const requestGenerico = {
  get: (url) => axios.get(url),
  post: (url, body) => axios.post(url, body),
  put: (url, body) => axios.put(url, body),
  delete: (url) => axios.delete(url),
};

export default requestGenerico;